import { Fragment } from 'react';
import { ButtonUI } from 'sonata-react-components';

import type { ComponentProps, ReactNode } from 'react';

export type EntityRowAction =
  | {
      disabled?: boolean;
      icon: string;
      iconClassName: string;
      id: string;
      onClick: () => void;
      shape?: ComponentProps<typeof ButtonUI>['shape'];
    }
  | { content: ReactNode; id: string; isCustomAction: true };

type Props = {
  actions: EntityRowAction[];
  /** BEM base of the list, to keep the `{list}__tableListRowsListRowActions` styles. */
  className: string;
};

/** Row actions with the same markup/classes as TaptapList's Row.Actions, so it inherits its styles. */
export function EntityRowActions({ actions, className }: Readonly<Props>) {
  return (
    <div className={`taptapListRowsListRowActions ${className}__tableListRowsListRowActions`} data-row-action>
      {actions.map(action =>
        'isCustomAction' in action ? (
          <Fragment key={action.id}>{action.content}</Fragment>
        ) : (
          <ButtonUI
            disabled={action.disabled}
            icon={action.icon}
            iconClassName={action.iconClassName}
            id={action.id}
            key={action.id}
            onClick={() => action.onClick()}
            shape={action.shape ?? 'link'}
            size="ultraSmall"
            type="secondary"
          />
        )
      )}
    </div>
  );
}
